// AuthContext.js
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";


const AuthContext = createContext({});

export function useAuth() {
  //console.log(useContext(AuthContext))
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState({
    ID: null,
    Title: null,
    FName: null,
    LName: null,
    AccountType: null,
    Password: null,
    EmailAddress: null,
    userSocialLink: null,
    ContactNumber: null,
    StreetAddress: null,
    City: null,
    Province: null,
    County: null,
    Code: null,
    LocalOrInt: null,
    Points: null,
    OrdersActive: null,
    PastOrders: null,
    AccountStatus: null,
    DateJoined: null,
    DateDeactivated: null,
    LoggedIn: false,
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [countItems, setCountItems] = useState(0);

  const loginUser = async (userData) => {
    console.log("logU:\n", userData);

    ///check user information in localStorage
    if (isAuthenticated()) {
      setUserInfo();
    }
  };

  const setUserInfo= async () =>{
    const result = getAuthUser();

      if (result) {
        setAuthUser(result);
        setAuthUser((prevData) => ({
          ...prevData,
          LoggedIn: true,
        }));
        setIsLoggedIn(true);
        
      } else {


      }
      

  }

  const logoutUser = async () => {
    clearAuthData();
    setAuthUser({
      ID: null,
      Title: null,
      FName: null,
      LName: null,
      AccountType: null,
      Password: null,
      EmailAddress: null,
      userSocialLink: null,
      ContactNumber: null,
      StreetAddress: null,
      City: null,
      Province: null,
      County: null,
      Code: null,
      LocalOrInt: null,
      Points: null,
      OrdersActive: null,
      PastOrders: null,
      AccountStatus: null,
      DateJoined: null,
      DateDeactivated: null,
      LoggedIn: false,
    });
    setIsLoggedIn(false);
  };

  function UpdateBagCount() {
    if (authUser)
      fetch(`/countBagItems?filter=UserID='${authUser.ID}'`)
        .then((response) => response.json())
        .then((data) => setCountItems(parseInt(data)))
        .catch((error) => console.error("Error fetching count:", error));
  }

  useEffect(() => {
    isAuthenticated();
  }, []);
 useEffect(() => {
    //console.log("uID:",authUser.ID);
    if(authUser.ID){
      UpdateBagCount();
    }
  }, [authUser, isLoggedIn]);
 
 
  function getToken() {
    return localStorage.getItem("authToken");
  }
  function getAuthUser() {
   
    return JSON.parse(localStorage.getItem("user"));
   
  }

  function checkAuthToken() {
    const token = getToken();
    if (token) {
      try {
        const decodedToken = jwtDecode(token);        
        const expiryTime = decodedToken.exp;
        const now = new Date().getTime() / 1000; // Current time in seconds
        if (now > expiryTime) {
          console.log("Token has expired");
          this.clearAuthData();
          //this.router.navigate(['/Login']);
          return false;
        }
        else{
          setUserInfo();          
        }
        return true;
      } catch (e) {
        console.error("Error decoding token:", e);
        clearAuthData();
        //this.router.navigate(['/Login']);
        return false;
      }
    }
    //this.router.navigate(['/Login']);
    return false;
  }

  function clearAuthData() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  }

  function isAuthenticated() {
    return checkAuthToken();
  }

  return (
    <AuthContext.Provider
      value={{
        authUser,
        isAuthenticated,
        isLoggedIn,
        setUserInfo,
        countItems,
        UpdateBagCount,
        loginUser,
        logoutUser,
        setIsLoggedIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
